<template>
    <div id="profile-basket" class="profile-basket">
        <div class="px-0 mb-4" v-for="item in basketItems" :key="item.id">
            <div class="d-flex align-center">
                <v-checkbox color="orange lighten-2" v-model="selected[item.id]" @change="selectItem(item.id)"></v-checkbox>
                <basket-single-card
                        :card-data="item"
                        @add-to-often="addToOften"
                        @delete-often="deleteOften"
                        @delete-order="deleteOrder"
                        @open-messages="openMessages"
                ></basket-single-card>
            </div>
        </div>
    </div>
</template>

<script>
    import BasketSingleCard from './BasketSingleCard';

    export default {
        name: "Basket",
        props:['items', 'options', 'selected'],
        components:{BasketSingleCard},
        data(){
            return {
                checked:{},
            }
        },
        computed: {
            basketItems(){
                return this.items;
            },
            basketOptions() {
                return this.options
            }
        },
        methods: {
            addToOften(id) {
                this.$emit('add-to-often', id);
            },
            deleteOften(id) {
                this.$emit('delete-often', id);
            },
            deleteOrder(id) {
                this.$emit('delete-order', id);
            },
            openMessages(id) {
                this.$emit('open-messages', id);
            },
            selectItem(id){
                this.$emit('select-item', {id: id, value: this.selected[id]});
            },
        }
    }
</script>

<style scoped>

</style>
